import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import {
  Icon,
  Intent,
  InputGroup,
  Hotkey,
  Hotkeys,
  HotkeysTarget,
} from '@blueprintjs/core';

//*/
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { COLOR } from 'config';


@HotkeysTarget
export default class SearchContainer extends React.Component {
  static propTypes = {
    handelSubmitSearch: PropTypes.func,
    form: PropTypes.object.isRequired,
  };

  state = {
  };

  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;
      if (this.props.handelSubmitSearch) this.props.handelSubmitSearch(value);
    });
  };

  renderHotkeys() {
    return (
      <Hotkeys>
        <Hotkey
          //global={true}
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={this.submit}
        />
      </Hotkeys>
    );
  }

  render() {
    const {
      getFieldDecorator,
    } = this.props.form;
    return (
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>Tìm kiếm</span>
              <Clearfix width={8} />
              <div style={{ flex: 1 }}>
                {getFieldDecorator('search', {
                  initialValue: '',
                })(<InputGroup placeholder='Tên cơ sở/dự án' />)}
              </div>
              <Clearfix width={8} />
              <Icon
                icon={IconNames.SEARCH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                onClick={this.submit}
              />
            </div>
          </Col>
        </Row>
        {this.props.expand}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BaseContainer/FormSearchType1Container.js